module.exports = __webpack_public_path__ + "d6266e00c63d33d2348febb9bfb9258b.svg";